// do these things only once
// even if you are using a history.js navigation

// imports --------------------------------------------------------------------
import * as Vars from './0-vars.js';
import * as Once from './2-once.js';
// import * as Page from './3-page.js';
import * as Resize from './4-resize.js';
import * as Scroll from './5-scroll.js';

// exported variables ---------------------------------------------------------
export let fromKeyboard = false;

// local variables ------------------------------------------------------------
const pulseSelector = '.button, .swiper-button-next, .swiper-button-prev'; // elements that get a pulse on click
let didPageInteraction = false; // to track first interaction for playing videos on low battery devices

// listeners function ---------------------------------------------------------
export const initListeners = () => {
  // console.log('listeners');
  
  // touch --------------------------------
  const hoverSelector = 'button, a, input, .header__nav-item';
  document.body.addEventListener('touchstart', event => { // also triggers on move
    // console.log('touchstart', event.target.classList[0]);

    // add touch hover classes
    let el = event.target.closest(hoverSelector);
    if (el) {
      const hoverEl = el;
      hoverEl.classList.add('hover');

      // if using css animation for hover effect, remove class after animation duration
      let duration = Vars.transitionFast;
      if (hoverEl.classList.contains('button')) duration = Vars.transitionDefault; // same as css animation duration

      setTimeout(() => {
        hoverEl.classList.remove('hover');
      }, duration); 
    }
  });

  document.body.addEventListener('touchend', event => {
    // console.log('touchend', event.target.classList[0]);

    // when not using css animation
    // let el = event.target.closest(hoverSelector);
    // if (el) el.classList.remove('hover');
  });

  // touch and mouse --------------------------------
  document.body.addEventListener('click', event => { // triggers on tap, not on move
    // console.log('click', event.target.classList[0]);

    // remove focus after click
    let el = event.target.closest('button, a, input[type="radio"], input[type="checkbox"], *[role="button"], input[type=range]');
    if (el && event.clientX !== 0 && event.clientY !== 0) el.blur();

    if ('aim' in Once && Once.aim) {
      Once.aim.classList.add('animate-it-mouse--click');

      setTimeout(() => {
        Once.aim.classList.remove('animate-it-mouse--click');
      }, Vars.transitionDefault); // same as .pulse duration
    }

    // pulse effect on buttons --------------------------------
    el = event.target.closest(pulseSelector);
    if (el) {
      const linkEl = el;
      linkEl.classList.add('pulse');

      setTimeout(() => {
        linkEl.classList.remove('pulse');
      }, Vars.transitionDefault); // same as .pulse duration
    }

    // play video on low battery devices  --------------------------------------------
    if (!didPageInteraction) {
      // actual autoplay videos, not ones that have autoplay from Fader.js
      const videoEls = document.querySelectorAll('video[autoplay]:not([data-autoplay="false"]):not([data-src=""])');
      videoEls.forEach(videoEl => videoEl.play());
      didPageInteraction = true;
    }

    // interaction  --------------------------------------------
    el = event.target.closest('button, p a'); // interaction acf selectors
    if (el) {
      // to section
      const sectionName = el.dataset.section;
      if (typeof sectionName !== 'undefined') {
        event.preventDefault();
        const sectionEl = document.querySelector('[data-name="' + sectionName + '"]');
        if (sectionEl) Scroll.scrollToEl(sectionEl);
      }
    }

    // hamburger
    el = event.target.closest('.hamburger');
    if (el) {
      document.body.classList.toggle('body--nav');
      if ('animator' in Once) Once.animator.blockResizeObserver = true; 
      if ('checkBlockScroll' in Scroll) Scroll.checkBlockScroll();
    }

    // remove hover from any item on touch devices
    const headerNavItemEls = document.querySelectorAll('.header__nav-item');
    headerNavItemEls.forEach(headerNavItemEl => headerNavItemEl.classList.remove('header__nav-item--active'));

    el = event.target.closest('.header__nav-item');
    if (el && (Vars.blTouch || Vars.mqPhablet.matches)) {
      el.classList.add('header__nav-item--active');
      Once.fader.setFaders();
    }

    // override previous
    el = event.target.closest('.flap__back');
    if (el)  {
      const headerNavItemEl =  el.closest('.header__nav-item--active');
      if (headerNavItemEl) headerNavItemEl.classList.remove('header__nav-item--active');
    }

    el = event.target.closest('.back-link');
    if (el)  {
      // check if there's a previous page in history and if it's from the same domain
      if (document.referrer && new URL(document.referrer).origin === window.location.origin) {
        window.history.back();
      } else {
        // go to homepage if no referrer or referrer is from different domain
        window.location.href = $url; // is homepage set in base.twig
      }
    }
    
    // filtering
    el = event.target.closest('button.button--filter');
    if (el) {
      const filter = el.getAttribute('data-filter');

      const buttons = document.querySelectorAll('.button--filter');
      buttons.forEach(button => button.classList.remove('button--active'));
      el.classList.add('button--active');

      const filterableEl = document.querySelector('.filterable');
      if (!filterableEl) return;

      filterableEl.classList.add('filterable--faded-out');

      // console.log(' scroll to filter');
      const scrollerEl = document.querySelector('#scroller');
      if (scrollerEl) Scroll.scrollToEl(scrollerEl, '', Resize.headerHeight, 'up');

      setTimeout(() => {
        // before adding hidden, because it's removed by fader
        Once.fader.fadeInHolderAgain(filterableEl);

        const allItemEls = filterableEl.querySelectorAll('.filterable__item');
        allItemEls.forEach(itemEl => itemEl.classList.remove('fader--br', 'fader--bl'));

        if (filter === 'all') {
          allItemEls.forEach(itemEl => itemEl.classList.remove('hidden'));
        } else {
          allItemEls.forEach(itemEl => itemEl.classList.add('hidden'));

          const filteredItemEls = filterableEl.querySelectorAll('.filterable__item[data-tags*="' + filter + '"]');
          filteredItemEls.forEach(itemEl => itemEl.classList.remove('hidden'));
        }

        filterableEl.classList.remove('filterable--faded-out');
      }, Vars.transitionDefault);
    }
  });

  // keyboard --------------------------------
  document.body.addEventListener('keydown', event => {
    // console.log('keydown', event.key);
    fromKeyboard = true;
  });

  // mouse and keyboard --------------------------------
  // mouseout, focusout listeners 
  const outHandler = event => {
    // use if (event.type === 'mouseout') to avoid keyboard blur
    if (Vars.blTouch) return;
    if (event.type === 'focusout' && !fromKeyboard) return;
    // console.log('outHandler', event.target.classList[0], event.type);

    // let el = event.target.closest(swiperHoverSelector);
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--hover');
    // }

    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--drag-hor');
    // }

    // let el = event.target.closest('.header__nav-item');
    // if(!el) {
    //   const activeHeaderNavItemEls = document.querySelectorAll('.header__nav-item--active');
    //   activeHeaderNavItemEls.forEach(activeHeaderNavItemEl => activeHeaderNavItemEl.classList.remove('header__nav-item--active'));
    // } 
  };

  // document.body.addEventListener('mouseleave', outHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseout', outHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusout', outHandler); // doesn't bubble or trigger on touch, triggers on keyboard blur and click on other button

  // mouseover, focusin listeners 
  const swiperHoverSelector = '.swiper-pagination-bullet, .swiper-button-next, .swiper-button-prev';
  const inHandler = event => {
    // use if (event.type === 'mouseover') to avoid keyboard focus
    if (Vars.blTouch) return;
    if (event.type === 'focusin' && !fromKeyboard) return;
    // console.log('inHandler', event.target.classList[0], event.type);

    // let el = event.target.closest(swiperHoverSelector);
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--hover');
    // }

    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--drag-hor');
    // }

    let el = event.target.closest('.header__nav-item');
    if (el) Once.fader.setFaders();

    if (event.type == 'focusin' && fromKeyboard) {
      // keyboard focus fixed footer, scroll there
      if (event.target.closest('.footer')) Scroll.animateScrollTop(1000000);

      // remove hover from any item if keyboard focus
      const headerNavItemEls = document.querySelectorAll('.header__nav-item');
      headerNavItemEls.forEach(headerNavItemEl => headerNavItemEl.classList.remove('header__nav-item--active'));

      el = event.target.closest('.header__nav-item');
      if (el) el.classList.add('header__nav-item--active');
    }

    fromKeyboard = false;
  };

  // document.body.addEventListener('mouseenter', inHandler, true); // bubbles to body, triggers on touch
  document.body.addEventListener('mouseover', inHandler); // doesn't bubble, triggers on touch
  document.body.addEventListener('focusin', inHandler); // doesn't bubble or trigger on touch, triggers on keyboard focus and mousedown on button


  // mousedown listener --------------------------------
  document.body.addEventListener('mousedown', event => {
    // console.log('mousedown', event.target.classList[0]);

    // el = event.target.closest('.swiper-wrapper');
    // if (el && Once.aim) {
    //   Once.aim.classList.add('animate-it-mouse--dragging-hor');
    // }
  }, true);

  // mousemove listener --------------------------------
  document.body.addEventListener('mousemove', event => {
    // console.log('mousemove', event.target.classList[0]);

    const x = event.clientX;
    const y = event.clientY;
  }, true);

  // mouseup listener --------------------------------
  document.body.addEventListener('mouseup', event => {
    // console.log('mouseup', event.target.classList[0]);

    // if (Once.aim) {
    //   Once.aim.classList.remove('animate-it-mouse--dragging-hor');
    // }
  }, true);
};

// functions -------------------------------------------------------------------

